import { Stepper } from "@shared/components/Stepper";
import { useRemoteUtilityId } from "@shared/selectors/globalSelectors";
import React, { useMemo } from "react";
import { CustomerInformationStep } from "./stepComponents/ConsumerInformationStep";
import { RequestDetailsStep } from "./stepComponents/RequestDetailsStep";
import { ReviewPaymentStep } from "./stepComponents/ReviewPaymentStep";

export const CreateReconnectionRequest: React.FC = () => {
  const remoteUtilityId = useRemoteUtilityId();
  const storageKey = `service-request-progress-${remoteUtilityId}`;
  // Memoize the steps array to prevent infinite re-renders
  const steps = useMemo(
    () => [
      {
        title: "Customer Information",
        slug: "customer-info", // Add slug for routing
        component: (
          <CustomerInformationStep
            remoteUtilityId={Number(remoteUtilityId)}
            storageKey={storageKey}
          />
        ),
        optional: false,
        infoTitle: "Customer Information Help",
        infoDescription:
          "Enter the customer's account details. You can use the 'Look Up' button to automatically populate fields if you have the account number.",
      },
      {
        title: "Select Service",
        slug: "service-selection", // Add slug for routing
        component: (
          <RequestDetailsStep
            remoteUtilityId={Number(remoteUtilityId)}
            storageKey={storageKey}
          />
        ),
        optional: false,
        infoTitle: "Service Selection Help",
        infoDescription:
          "Browse and select the service you need. Use the search bar to quickly find specific services. Each service shows pricing and description to help you choose.",
      },
      {
        title: "Review & Payment",
        slug: "review-payment", // Add slug for routing
        component: (
          <ReviewPaymentStep
            remoteUtilityId={Number(remoteUtilityId)}
            storageKey={storageKey}
          />
        ),
        optional: false,
        infoTitle: "Review & Payment Help",
        infoDescription:
          "Review all your service details and payment information before submitting your request.",
      },
    ],
    [],
  ); // Only recreate when requestData or handleStateUpdate changes

  return (
    <div>
      <Stepper
        steps={steps}
        onStepChange={() => {}}
        onStepSave={async (stepIndex, stepData, isDirty) => {
          // Storage is handled at component level using step helpers
        }}
        enableApiSave={false}
        saveOnStepChange={false}
        trackDirtyState={false}
        autoSave={false}
        persistProgress={false}
        allowSkip={false} // Set to false since all steps are required
        storageKey={storageKey}
        enableRouting={true} // Enable hash-based routing (no 404s on refresh)
        onValidation={undefined} // basePath is not needed for hash-based routing
        onComplete={() => {}}
        showDraftResume={false}
      />
    </div>
  );
};
